//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { MappedZone_MapAndZoneDTO } from 'src/app/core/models/system/mapping/mapped-zone-map-and-zone.dto';
import { Observable, lastValueFrom, map, of } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class MappedZones_MapAndZoneService {
  
  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<MappedZone_MapAndZoneDTO[]>(environment.eSimApi + eSimApiPaths.MappedZones_MapAndZone)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(mappedZone_MapAndZone: MappedZone_MapAndZoneDTO) {
    return {id: mappedZone_MapAndZone.id, description: mappedZone_MapAndZone.mapName + " - " + mappedZone_MapAndZone.zoneName};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
